import { observer } from "mobx-react";
import { IApplicationFilterComponent } from "../BaseFilterComponents/IApplicationFilterComponent";
import React from "react";
import AcxToggleButton from "components/UI/AcxToggleButton";
import { Sentiment } from "stores/ApplicationFilters/Filters/Sentiment";

export const SentimentFilter = observer(function (
    props: IApplicationFilterComponent,
) {
    const sentimentId =
        props.filterKey === "beginningSentiment"
            ? "starting-sentiment"
            : "ending-sentiment";

    return (
        <AcxToggleButton
            id={`application-filters-${sentimentId}`}
            exclusive
            items={[
                {
                    id: `application-filters-${sentimentId}-negative`,
                    element: "Negative",
                    value: Sentiment.Negative,
                },
                {
                    id: `application-filters-${sentimentId}-neutral`,
                    element: "Neutral",
                    value: Sentiment.Neutral,
                },
                {
                    id: `application-filters-${sentimentId}-positive`,
                    element: "Positive",
                    value: Sentiment.Positive,
                },
            ]}
            onChange={(value) => {
                if (props.filterKey === "beginningSentiment")
                    props.store.setBeginningSentiment(value);
                else if (props.filterKey === "endingSentiment")
                    props.store.setEndingSentiment(value);
            }}
            defaultValue={props.store[props.filterKey]}
            justifyContent="center"
            groupFlexGrow={1}
        />
    );
});
